import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { useQueryClient } from "@tanstack/react-query";
import { tipsApi } from "@/services/api/tips";
import { Smile, Heart, Star, Sparkles, Trophy, Flame, PartyPopper, Music, Laugh, Globe } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useEffect } from 'react';
import gsap from 'gsap';




const EMOJI_OPTIONS = [
  { icon: <Heart className="w-5 h-5" />, value: "❤️" },
  { icon: <Flame className="w-5 h-5" />, value: "🔥" },
  { icon: <Star className="w-5 h-5" />, value: "⭐" },
  { icon: <Sparkles className="w-5 h-5" />, value: "✨" },
  { icon: <PartyPopper className="w-5 h-5" />, value: "🎉" },
  { icon: <Smile className="w-5 h-5" />, value: "🥳" },
  { icon: <Laugh className="w-5 h-5" />, value: "😎" },
  { icon: <Trophy className="w-5 h-5" />, value: "💫" },
  { icon: <Music className="w-5 h-5" />, value: "💝" },
  { icon: <Sparkles className="w-5 h-5" />, value: "💖" },
  { icon: <Heart className="w-5 h-5" />, value: "🦋" },
  { icon: <Star className="w-5 h-5" />, value: "🌈" },
  { icon: <PartyPopper className="w-5 h-5" />, value: "🎊" },
  { icon: <Smile className="w-5 h-5" />, value: "💪" },
  { icon: <Heart className="w-5 h-5" />, value: "🌸" }
];

export default function SubmitTip() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [emoji, setEmoji] = useState("❤️");
  const [addedBy, setAddedBy] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleEmojiClick = (value: string) => {
    setEmoji(value);

    const audio = new Audio("/sfx/sort.aac");
    audio.play();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !description.trim() || !addedBy.trim()) return;

    setIsSubmitting(true);
    try {
      await tipsApi.submitTip({
        title: title.trim(),
        description: description.trim(),
        emoji,
        addedBy: addedBy.trim(),
        status: "draft",
      });

      queryClient.invalidateQueries({ queryKey: ["tips"] });
      navigate("/thank-you");
    } catch (error) {
      console.error("Error submitting tip:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to submit tip. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const tl_sub_lockup = gsap.timeline();
    tl_sub_lockup
      .from("#sub_KV-1", { opacity: 0, scale: 0, duration: 1.5, ease: "power1.inOut" })
      .from("#sub_KV-1B", { opacity: 0, scale: 0, duration: 1.5, ease: "power1.inOut" }, "-=1.3")
      .from("#sub_KV-4", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.0")
      .from("#sub_KV-3", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.3")
      .from("#sub_KV-5, #sub_KV-2", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.4")
      .from("#sub_KV-6", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.4")
      .from("#sub_KV-7", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.4")
      .from("#mainCopy_Gcover", { scale: 0, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=1.4")
      .from(".form_entry_f1", { opacity: 0, y:"30", duration: 0.8, ease: "power1.inOut" }, "-=1.4")
      .from(".form_entry_f2", { opacity: 0, y:"30",  duration: 0.8, ease: "power1.inOut" }, "-=0.7")
      .from(".form_entry_f3", { opacity: 0, y:"30",  duration: 0.8, ease: "power1.inOut" }, "-=0.7")
      .from(".form_entry_f4", { opacity: 0, y:"30",  duration: 0.8, ease: "power1.inOut" }, "-=0.7")
      .fromTo("#entry_btn1_G", { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.7)" }, "-=0.7");

     
      

      ;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      
      
      
      
      
      <div className="w-full h-full p-2 absolute">

      <div className="relative mt-[10px]" id="sub_KV" style={{height: '230px', width: '100%', display: 'flex', justifyContent: 'center'}}>
<div className="absolute w-full max-w-[250px] h-auto sub_KV-1_G" id="sub_KV-1_G">
  <img src="/imgs/KV-1.png" alt="Live Your Best Lip!" className="w-full h-auto" id="sub_KV-1" />
</div>
<div className="absolute w-full max-w-[250px] h-auto sub_KV-1_G" id="sub_KV-1_G2">
  <img src="/imgs/KV-1B.png" alt="Live Your Best Lip!" className="w-full h-auto" id="sub_KV-1B" />
</div>
<div className="absolute w-full max-w-[250px] h-auto" id="sub_KV-2_G">
  <img src="/imgs/KV-2.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-2" />
</div>
<div className="absolute w-full max-w-[250px] h-auto floating">
  <img src="/imgs/KV-3.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-3" />
</div>
<div className="absolute w-full max-w-[250px] h-auto floating2">
  <img src="/imgs/KV-4.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-4" />
</div>
<div className="absolute w-full max-w-[250px] h-auto" id="sub_KV-5_G">
  <img src="/imgs/KV-5.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-5" />
</div>
<div className="absolute w-full max-w-[250px] h-auto" id="sub_KV-6-7_G">
  <img src="/imgs/KV-6.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-6" />
  <img src="/imgs/KV-7.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="sub_KV-7" />
</div>
</div>
        <div id="mainCopy_Gcover" className="relative flex flex-col w-auto h-auto items-center mt-0 mb-0">
          {/* Copy1 and Copy1 Cover */}
          <div className="flex-shrink-0 relative z-10 mb-[-10px]">
            <img
              src="/imgs/copy_insert.png"
              alt="Live Your Best Lip!"
              className="w-[686px] h-auto"
              id="copy1entry"
            />
            <img
              src="/imgs/copy_insertcover.png"
              alt="Live Your Best Lip!"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[686px] h-auto z-10"
              id="copy1_cover"
            />
            {/* Shine Effect for Copy1 */}
            <div className="shine-container absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
              <div className="shine absolute top-0 left-0 w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
            </div>
          </div>

          {/* Copy2 and Copy2 Cover */}
          <div className="flex-shrink-0 -translate-y-[-1.25%] relative  z-20">
            <img
              src="/imgs/copy_insert2.png"
              alt="Live Your Best Lip!"
              className="w-[973px] h-auto"
              id="copy2entry"
            />
            <img
              src="/imgs/copy_insert2cover.png"
              alt="Live Your Best Lip!"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[973px] h-auto z-10"
              id="copy2_cover"
            />
            {/* Shine Effect for Copy2 */}
            <div className="shine-container absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
              <div className="shine absolute top-0 left-0 w-[50%] h-full bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
            </div>
          </div>
        </div>
        <style>{`
  .placeholder-custom::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`}</style>
        <form onSubmit={handleSubmit} className="space-y-4 mt-[-50px] form_entry">
          <div className="space-y-2 form_entry_f1">
            <label htmlFor="title" className="text-4xl text-white font-DiloWorld">
              <div className="titles">Title</div>{" "}
              <div className="descs text-[0.6em] text-white/40 font-Metric mb-[-8px]">({30 - title.length} characters remaining)</div>
            </label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value.slice(0, 30))}
              placeholder="Enter a catchy title..."
              required
              maxLength={30}
              className="h-20 w-full px-10 py-6 border-4 border-white rounded-2xl bg-transparent text-white placeholder-custom placeholder-opacity-70 text-7xl leading-tight focus:outline-none focus:ring-4 focus:ring-white"
              style={{ fontSize: "1.5rem" }} // Fallback inline style if Tailwind fails
            />
          </div>

          <div className="space-y-2 pt-12 form_entry_f2">
            <label htmlFor="description" className="text-4xl text-white font-DiloWorld">
              <div className="titles">description</div>{" "}
              <div className="descs text-[0.6em] text-white/40 font-Metric mb-[-8px]">({50 - description.length} characters remaining)</div>
            </label>
            <Textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value.slice(0, 50))}
              placeholder="Share your university survival tip..."
              required
              maxLength={50}
              className="h-28 w-full px-10 py-6 border-4 border-white rounded-2xl bg-transparent text-white placeholder-custom placeholder-opacity-70 text-7xl leading-tight focus:outline-none focus:ring-4 focus:ring-white"
              style={{ fontSize: "1.5rem" }} // Fallback inline style if Tailwind fails
            />
          </div>

          <div className="space-y-2 pt-12  form_entry_f3">
            <label className="text-4xl text-white font-DiloWorld">
              <div className="titles">Choose an Emoji</div>
            </label>
            <div className="grid grid-cols-3 gap-2">
              {EMOJI_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => handleEmojiClick(option.value)}
                  className={cn(
                    "m-0 p-4 mx-5 rounded-lg transition-all duration-200 hover:bg-[#000e65]/50 hover:scale-[1.2] flex justify-center items-center",
                    emoji === option.value ? "bg-[#000e65]/50" : "bg-transparent"
                  )}
                >
                  <span className="text-[10vw]">{option.value}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-4 pt-12 pb-16 form_entry_f4">
            <label htmlFor="addedBy" className="text-4xl text-white font-DiloWorld">
              <div className="titles mb-[-8px]">Your Name</div>
            </label>
            <Input
              id="addedBy"
              value={addedBy}
              onChange={(e) => setAddedBy(e.target.value)}
              placeholder="Enter your name..."
              required
              className="h-20 w-full px-10 py-6 border-4 border-white rounded-2xl bg-transparent text-white placeholder-custom placeholder-opacity-70 text-7xl leading-tight focus:outline-none focus:ring-4 focus:ring-white"
              style={{ fontSize: "1.5rem" }} // Fallback inline style if Tailwind fails
            />
          </div>

          <div className="flex justify-center items-center" id="entry_btn1_G">
  <div className="entry_button-container flex justify-center items-center mb-16">
    <div className="entry_button">
      <div className="entry_button-top-rect"></div>
      <div className="entry_button-bottom-rect"></div>
      <span className="entry_button-text font-Metric">
        <Button 
          type="submit" 
          className="text-6xl bg-transparent"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Share Tip"}
        </Button>
      </span>
    </div>
  </div>
</div>
        </form>
      </div>
    </div>
  );
}
